<template>
    <el-dialog @open="handleOpen" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" custom-class="dialogForm" class="measDialog" width="80%" height="90%" min-width="800px" :show-close="!submitLoading" :title="code ? '编辑课件' : '新增课件'">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" :rules="rules" ref="ruleForm" v-loading="fetchLoading">
                <el-form-item label="课件名称" prop="name">
                    <el-input v-model="form.name" clearable maxlength="50" show-word-limit placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="课件类型" prop="coursewaretype">
                    <el-radio @change="coursewareSuffix = videoSuffixes" v-model="form.coursewaretype" :label="1" class="ml-10">视频</el-radio>
                    <el-radio @change="coursewareSuffix = audioSuffixes" v-model="form.coursewaretype" :label="2">音频</el-radio>
                    <el-radio @change="coursewareSuffix = pdfSuffixes" v-model="form.coursewaretype" :label="3">PDF</el-radio>
                </el-form-item>
                <el-form-item label="课件内容" prop="wareattid">
                    <upload @success="handleUploadSuccess" @error="handleUploadFail" ref="filePostman" :scope-type="106" :file-max-size="1024 * 1000" :accept="coursewareSuffix" show-file-list>
                        <el-button type="primary" plain style="margin-bottom: 0">上传课件</el-button>
                    </upload>
                </el-form-item>
                <el-form-item label="备注" prop="summary">
                    <el-input v-model="form.summary" type="textarea" autosize resize="none" maxlength="200" placeholder="请输入内容" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <span slot="footer">
            <div class="flex jc-fd ai-c">
                <el-button @click="handleClose" :disabled="submitLoading">取消</el-button>
                <el-button @click="() => submit(0)" :disabled="submitLoading || fetchLoading">保存为草稿</el-button>
                <el-button @click="() => submit(1)" type="primary" :disabled="submitLoading || fetchLoading">保存并发布</el-button>
            </div>
        </span>
    </el-dialog>
</template>
<script>
import Upload from '@/components/measComponents/uploadFile/uploadFile.vue'
import {
  saveCourseware,
  getCoursewareDetails
} from '@/api/measApi/coursewareManage'
export default {
  components: {
    Upload
  },
  data: () => ({
    submitLoading: false,
    fetchLoading: false,
    activeCoursewareSuffix: '',
    coursewareSuffix: '.mp4,.rm,.f4v,.avi,.flv,.3gp,.mpeg,.wmv,.rmvb', // 课件要求后缀
    videoSuffixes: '.mp4,.rm,.f4v,.avi,.flv,.3gp,.mpeg,.wmv,.rmvb', // 视频文件后缀范围
    audioSuffixes: '.mp3,.cda,.aac,.wave,.ape,.wma,.ogg,.flac', // 音频文件后缀范围
    pdfSuffixes: '.pdf', // pdf文件后缀范围
    form: {
      code: '',
      name: '', // 课件名称
      coursewaretype: 1, // 课件类型
      wareattid: '', // 课件附件ID
      wareatturl: '', // 课件附件URL
      summary: '', // 简介
      savetype: 0, // 保存状态
      filesize: '',
      duration: '',
      warefilename: '' // 附件名称
    },
    // 表单规则
    rules: {
      name: [{ required: true, message: '请输入课件名称', trigger: 'change' }],
      coursewaretype: [
        { required: true, message: '请选择课件类型', trigger: 'change' }
      ],
      wareattid: [
        { required: true, message: '请上传课件内容', trigger: 'change' }
      ]
    }
  }),
  props: {
    // 对话框可见性
    visible: {
      require: false,
      type: Boolean,
      default: false
    },
    // 编辑的code
    code: {
      require: false,
      type: String,
      default: ''
    }
  },
  methods: {
    // 提交表单
    async submit(saveType = 0) {
      if (
        this.activeCoursewareSuffix &&
        this.coursewareSuffix.indexOf(this.activeCoursewareSuffix) < 0
      ) {
        return this.$message.warning(
          '当前课件内容格式不符合要求，请重新选择上传！'
        )
      }
      this.form.savetype = saveType
      if (saveType === 1) {
        await this.$confirm('保存后将不可修改，继续吗？', {
          customClass: 'measElMessage'
        })
        this.formValidate()
      } else {
        this.formValidate()
      }
    },
    // 表单验证
    formValidate() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) {
          return false
        }
        this.saveCourseware()
      })
    },
    // 新增/修改课件
    async saveCourseware() {
      try {
        this.submitLoading = true
        const res = await saveCourseware(this.form)
        if (res.code === '000') {
          this.$message.success(res.msg)
          this.$emit('complete')
          this.handleClose()
        }
        this.submitLoading = false
      } catch {
        this.submitLoading = false
      }
    },
    // 获取课件详情
    async getCoursewareDetails() {
      try {
        this.fetchLoading = true
        const res = await getCoursewareDetails({ code: this.code })
        if (res.code === '000') {
          Object.assign(this.form, res.data)
          this.$refs.filePostman.fileList = [
            {
              name: this.form.warefilename,
              url: this.form.wareatturl,
              type: this.form.coursewaretype
            }
          ]
        }
        this.fetchLoading = false
      } catch {
        this.fetchLoading = false
      }
    },
    // 文件上传成功
    handleUploadSuccess(e) {
      this.activeCoursewareSuffix = e.fname.slice(e.fname.lastIndexOf('.'))
      this.form.wareattid = e.key
      this.form.wareatturl = e.atturl
      this.form.filesize = e.fsize
      if (e.duration) {
        this.form.duration = e.duration === 'null' ? 0 : Math.floor(e.duration)
      } else {
        this.form.duration = 0
      }
      this.form.warefilename = e.fname
      this.$refs.ruleForm.validate()
    },
    // 文件上传失败
    handleUploadFail(err) {
      this.$message.warning('上传失败！错误信息：' + err)
    },
    // 对话框打开时
    handleOpen() {
      if (this.code) {
        this.getCoursewareDetails()
      }
    },
    // 对话框关闭时
    handleClose() {
      this.$refs.filePostman.clearFiles()
      Object.assign(this.form, this.$options.data().form)
      this.coursewareSuffix = this.videoSuffixes
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
      this.$emit('update:visible', false)
    }
  }
}
</script>
